import { render, staticRenderFns } from "./InvoiceCenter.vue?vue&type=template&id=35445156&scoped=true&"
import script from "./InvoiceCenter.vue?vue&type=script&lang=js&"
export * from "./InvoiceCenter.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCenter.vue?vue&type=style&index=0&id=35445156&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35445156",
  null
  
)

export default component.exports